/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientIdentity } from './';
import {
    ClientIdentityFromJSON,
    ClientIdentityFromJSONTyped,
    ClientIdentityToJSON,
} from './';
import type { Logo } from './';
import {
    LogoFromJSON,
    LogoFromJSONTyped,
    LogoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomerUserResource
 */
export interface CustomerUserResource {
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResource
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResource
     */
    companyName?: string;
    /**
     * 
     * @type {Logo}
     * @memberof CustomerUserResource
     */
    companyLogo?: Logo;
    /**
     * 
     * @type {number}
     * @memberof CustomerUserResource
     */
    companyCollaborators?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserResource
     */
    companyWithInvoiceBeforePayment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserResource
     */
    ownerOfCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserResource
     */
    canSendInvitations: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserResource
     */
    clientAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerUserResource
     */
    clientFees?: number;
    /**
     * 
     * @type {Array<ClientIdentity>}
     * @memberof CustomerUserResource
     */
    clientIdentities: Array<ClientIdentity>;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserResource
     */
    confidentialRelations?: boolean;
}

/**
 * Check if a given object implements the CustomerUserResource interface.
 */
export function instanceOfCustomerUserResource(value: object): value is CustomerUserResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('canSendInvitations' in value) || value['canSendInvitations'] === undefined) return false;
    if (!('clientAdmin' in value) || value['clientAdmin'] === undefined) return false;
    if (!('clientIdentities' in value) || value['clientIdentities'] === undefined) return false;
    return true;
}

export function CustomerUserResourceFromJSON(json: any): CustomerUserResource {
    return CustomerUserResourceFromJSONTyped(json, false);
}

export function CustomerUserResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerUserResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'firstName': json['firstName'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyLogo': json['companyLogo'] == null ? undefined : LogoFromJSON(json['companyLogo']),
        'companyCollaborators': json['companyCollaborators'] == null ? undefined : json['companyCollaborators'],
        'companyWithInvoiceBeforePayment': json['companyWithInvoiceBeforePayment'] == null ? undefined : json['companyWithInvoiceBeforePayment'],
        'ownerOfCompany': json['ownerOfCompany'] == null ? undefined : json['ownerOfCompany'],
        'canSendInvitations': json['canSendInvitations'],
        'clientAdmin': json['clientAdmin'],
        'clientFees': json['clientFees'] == null ? undefined : json['clientFees'],
        'clientIdentities': ((json['clientIdentities'] as Array<any>).map(ClientIdentityFromJSON)),
        'confidentialRelations': json['confidentialRelations'] == null ? undefined : json['confidentialRelations'],
    };
}

export function CustomerUserResourceToJSON(value?: CustomerUserResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'firstName': value['firstName'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'companyLogo': LogoToJSON(value['companyLogo']),
        'companyCollaborators': value['companyCollaborators'],
        'companyWithInvoiceBeforePayment': value['companyWithInvoiceBeforePayment'],
        'ownerOfCompany': value['ownerOfCompany'],
        'canSendInvitations': value['canSendInvitations'],
        'clientAdmin': value['clientAdmin'],
        'clientFees': value['clientFees'],
        'clientIdentities': ((value['clientIdentities'] as Array<any>).map((v) => ClientIdentityToJSON(v))),
        'confidentialRelations': value['confidentialRelations'],
    };
}

